import merge from 'lodash/merge';
// Configuration centralisée des langues
import {LANGUAGES, SUPPORTED_LANGUAGE_CODES, DEFAULT_LANGUAGE} from './languageConfig';
// adaptateurs de date
import {
  fr as frFRAdapter,
  enUS as enUSAdapter,
  nl as nlNLAdapter,
  de as deDEAdapter,
} from 'date-fns/locale';
// composants de base MUI
import {
  frFR as frFRCore,
  enUS as enUSCore,
  nlNL as nlNLCore,
  deDE as deDECore,
} from '@mui/material/locale';
// sélecteurs de date
import {
  frFR as frFRDate,
  enUS as enUSDate,
  nlNL as nlNLDate,
  deDE as deDEDate,
} from '@mui/x-date-pickers/locales';
// grille de données
import {
  frFR as frFRDataGrid,
  enUS as enUSDataGrid,
  nlNL as nlNLDataGrid,
  deDE as deDEDataGrid,
} from '@mui/x-data-grid';

/**
 * Mapping des locales MUI/date-fns par code de langue
 * Permet d'associer les configurations techniques MUI aux langues
 */
const LOCALE_ADAPTERS = {
  fr: frFRAdapter,
  en: enUSAdapter,
  nl: nlNLAdapter,
  de: deDEAdapter,
};

const LOCALE_SYSTEM_VALUES = {
  fr: merge(frFRDate, frFRDataGrid, frFRCore),
  en: merge(enUSDate, enUSDataGrid, enUSCore),
  nl: merge(nlNLDate, nlNLDataGrid, nlNLCore),
  de: merge(deDEDate, deDEDataGrid, deDECore),
};

/**
 * Configuration complète des langues pour MUI et date-fns
 * Combine les métadonnées centralisées avec les locales techniques
 */
export const allLangs = SUPPORTED_LANGUAGE_CODES.map((code) => ({
  ...LANGUAGES[code],
  value: code, // Alias pour compatibilité avec le code existant
  systemValue: LOCALE_SYSTEM_VALUES[code],
  adapterLocale: LOCALE_ADAPTERS[code],
}));

export const defaultLang = allLangs.find((lang) => lang.code === DEFAULT_LANGUAGE) || allLangs[0];

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
